import { forwardRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { BiCopy, BiEdit } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { TbLockAccess } from "react-icons/tb";
import { VscCompassActive, VscPreview } from "react-icons/vsc";
import { useSelector } from "react-redux";
import editIcon from "../../../resources/images/pencile.svg"
import deleteIcon from "../../../resources/images/delete.svg"
import Move from "../../../resources/images/Move.svg"
import Refer from "../../../resources/images/Refer.svg"


import { toast } from "react-toastify";
import { unsecuredCopyToClipboard } from "../../../helpers";
const CustomToggle = forwardRef(({ children, onClick }, ref) => (
  <span
    className="action-drop-down"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
    <span className="threedots" />
  </span>
));
const actionMenu = (props) => {
  const user = useSelector((state) => state.authentication.user);
  const companySettings = useSelector((state) => state.company.companySettings);
  const deleteClick = () => {
    if (props?.row?.id) {
      props.setDeleteId(props?.row?.id);
    }
    if (props?.setActiveRow) {
      props?.setActiveRow(props?.row)
    }
    if (props?.type === "resource" && props?.row?.userId) {
      props.setDeleteId(props?.row?.userId);
    }
  };
  const copyJobLink = () => { 
    let domain = companySettings?.domain;
    if (!domain) {
      domain = user?.domain;
    }
    const externalLink = `${domain}/application/${props?.row?.externalId}/${props.row.jobTitle.trim().replaceAll(' ', '-').toLowerCase()}-jobs-in-${props.row.location.trim().replaceAll(' ', '-').toLowerCase()}`;
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(externalLink);
    } else {
      unsecuredCopyToClipboard(externalLink);
    }

    toast.success("Link has been copied to clipboard");
  };

  const changeStatus = () => {
    if (props?.row) {
      props.setActiveData({...props?.row});
    }
  }

  const changeRole = () => {
    if (props?.row) {
      props.setRoleData({...props?.row});
    }
  }

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} />
      <Dropdown.Menu className="drop-itm">
        {props.type === 'openings' ? 
            (props.row.jobStatus === 'Drafted' || props.row.jobStatus === 'Active') && !props?.referredProfile  ? 
            <Dropdown.Item onClick={() => props.setEditedData(props?.row)}>
              <img src={editIcon} className="drop-icon" /> Edit
            </Dropdown.Item>
            : 
            !props?.referredProfile &&
            <Dropdown.Item onClick={() => props.setEditedData(props?.row)}>
              {" "}
              <VscPreview className="drop-icon" />Preview
            </Dropdown.Item>
            :
            !props?.referredProfile &&
            <Dropdown.Item onClick={() => props.setEditedData(props?.row)}>
            <img src={editIcon} className="drop-icon" /> Edit
            </Dropdown.Item>
            }
        {/* {props?.type === "resource" ?
          props?.row?.status ?
            <Dropdown.Item onClick={() => deleteClick()}>
              {" "}
              <img src={deleteIcon} className="drop-icon" /> Delete
            </Dropdown.Item> : ""
          :<Dropdown.Item onClick={() => deleteClick()}>
            {" "}
            <RiDeleteBinLine className="drop-icon" /> Delete
          </Dropdown.Item>
        } */}
          {props?.type !== "resource" && props.row.jobStatus !== 'Closed' && !props?.referredProfile ?
          props?.row?.status ?
            <Dropdown.Item onClick={() => deleteClick()}>
              {" "}
              <img src={deleteIcon} className="drop-icon" /> Delete
            </Dropdown.Item> : ""
          :""
        }
        {props?.type === "openings" && props.row.jobStatus === 'Active' && props.row.jobType === 'external' ? (
          <Dropdown.Item onClick={() => copyJobLink()}>
            {" "}
            <BiCopy className="drop-icon" /> Copy Link
          </Dropdown.Item>
        ) : (
          ""
        )}
        {props?.type === "openings" && !props?.referredProfile ? (
          <Dropdown.Item onClick={() => {
            props?.setJobId(props?.row.id);
            props?.setJobTitle(props?.row.jobTitle);
            props?.setJobProfileName(props?.row.job_profile.name);
            props?.addPositionToggleTwo()
          }}>
            {" "}
            <img src={Refer} className="drop-icon" />Refer
          </Dropdown.Item>
        ) : (
          ""
        )}
        {props?.type === "resource" && user?.userId !== props?.row?.userId ? (
          <>
          <Dropdown.Item onClick={() => changeStatus()}>
             {" "}
             <VscCompassActive className="drop-icon" /> Mark as {props?.row?.status ? "Inactive" : "Active"}
           </Dropdown.Item>
            {user && user?.userRole === 1 ?
              <Dropdown.Item onClick={() => changeRole()}>
                {" "}
                <TbLockAccess className="drop-icon" /> Access
              </Dropdown.Item> : ""
            }
          </>
        ) : ""}
        {props?.referredProfile  ?  
          <>
            <Dropdown.Item onClick={() => {
              props?.setCandidateId(props?.row.cid);
              props.referredProfileToggle()
            }}>
              <img src={Move} className="drop-icon" />Move to the job board
            </Dropdown.Item>
            {/* <Dropdown.Item>
              {" "}
              <img src={deleteIcon} className="drop-icon" /> Delete
            </Dropdown.Item> */}
          </>          
          : ""
        }
      </Dropdown.Menu>
    </Dropdown >
  );
};

export default actionMenu;
